<template>
  <button :class="{ main, deactivated, transparent }" @click.prevent="click"><slot /></button>
</template>
<script>
  export default {
    name: 'big-button-component',
    props: {
      href: String,
      action: Function,
      main: Boolean,
      deactivated: Boolean,
      transparent: Boolean,
    },
    methods: {
      click() {
        if (this.href) {
          this.$router.push(this.href)
        } else if (this.action) {
          this.action()
        }
      },
    },
  }
</script>
<style scope lang="scss">
  button {
    position: relative;
    background-color: $button-background;
    color: $button-color;
    border: 1px solid $button-color;
    font-size: 20px;
    padding: 10px 30px;
    border-radius: 5px;
    cursor: pointer;
    &.main {
      background: $button-color;
      color: $button-background;
      &.deactivated {
        background: transparent;
        color: $button-deactivated-background;
        border: 1px dotted #aaa;
      }
      &:hover {
        background: $color-3;
      }
    }
    &.deactivated {
      pointer-events: none;
      background: $button-deactivated-background;
      color: $button-deactivated-color;
    }
    &.transparent {
      background: transparent;
    }
    span {
      margin-right: 5px;
    }
  }
</style>